import React from 'react';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { matchUrlPathname } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { useRouteByName } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@atlassian/jira-software-devops-fedramp-utils/src/index.tsx';
import { messages } from './messages.tsx';

type ToolchainMenuItemProps = {
	projectId: number;
	projectKey: string;
};

export const ToolchainMenuItem = ({ projectId, projectKey }: ToolchainMenuItemProps) => {
	const { formatMessage } = useIntl();
	const toolchainRoute = useRouteByName('project-settings-software-toolchain-team-managed');

	// Don't render MenuItem if FedRAMP enabled
	if (isDevopsFeatureDisabledInFedRamp()) {
		return null;
	}

	const baseSettingsUrl = getNextgenSettingsUrl(SOFTWARE_PROJECT, projectKey);

	return toolchainRoute ? (
		<MenuItem
			analytics={{ itemId: 'toolchain' }}
			selectedOn={['project-settings-software-toolchain-team-managed']}
			data-test-id="navigation-apps-sidebar-next-gen.ui.menu.settings.toolchain-menu-item.menu-item-connections"
			to={toolchainRoute}
			params={{ projectKey }}
			query={{ projectId: String(projectId) }}
			prefetch="hover"
		>
			{formatMessage(messages.itemToolchain)}
		</MenuItem>
	) : (
		<MenuItem
			analytics={{ itemId: 'toolchain' }}
			href={`${baseSettingsUrl}/toolchain?projectId=${projectId}`}
			selectedOn={matchUrlPathname()}
			data-test-id="navigation-apps-sidebar-next-gen.ui.menu.settings.toolchain-menu-item.menu-item-connections"
		>
			{formatMessage(messages.itemToolchain)}
		</MenuItem>
	);
};
